export default "__VITE_ASSET__DoqXboBx__"